import { render, staticRenderFns } from "./AvatarGridSelect.vue?vue&type=template&id=20063b71&scoped=true&"
import script from "./AvatarGridSelect.vue?vue&type=script&lang=js&"
export * from "./AvatarGridSelect.vue?vue&type=script&lang=js&"
import style0 from "./AvatarGridSelect.vue?vue&type=style&index=0&id=20063b71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20063b71",
  null
  
)

export default component.exports